import { ref, toValue } from "vue"
import axios from "axios"

const path = ext => `/public/domains/${ext}`

const useDomainValidation = (subdomain, fnOnDomainValidationSuccess) => {
  const error = ref(false)
  const errorMessage = ref("")
  const isLoading = ref(false)

  const validateDomain = async () => {
    error.value = false
    errorMessage.value = ""

    if (!toValue(subdomain)) {
      return
    }

    if (/^[a-zA-Z0-9-]+$/.test(toValue(subdomain))) {
      try {
        isLoading.value = true
        const { data } = await axios.get(path(toValue(subdomain)))
        if (!data.available) {
          errorMessage.value = data.message
          error.value = !data.available
        }
        else {
          fnOnDomainValidationSuccess?.()
        }
      }
      catch ({ response, message }) {
        errorMessage.value = response?.data?.message || message
        error.value = true
      }
      finally {
        isLoading.value = false
      }
    }
    else {
      errorMessage.value = "Please enter only lowercase alphanumeric characters and hyphens."
      error.value = true
    }
  }

  return {
    validateDomain,
    error,
    errorMessage,
    isLoading,
  }
}

export {
  useDomainValidation,
}
